import styled from 'styled-components';
interface DivWidth {
  widthRem: string | undefined;
}

export const Container = styled.div<DivWidth>`
  width: ${(props) => (props.widthRem ? `${props.widthRem}rem` : '8.5rem')};
`;
